import { baseApi, apiTags } from "../baseApi";
import type { Permission } from "../types/api.types";

export const permissionsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getPermissions: builder.query<Permission[], void>({
            query: () => ({
                resource: "permission",
                action: "index",
                method: "GET",
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [
                          { type: apiTags.Permission, id: "LIST" },
                          ...result.map((item) => ({ type: apiTags.Permission, id: item.id })),
                      ]
                    : [{ type: apiTags.Permission, id: "LIST" }],
        }),
        getUserPermissions: builder.query<Permission[], void>({
            query: () => ({
                resource: "permission-user",
                action: "index",
                method: "GET",
            }),
            providesTags: [{ type: apiTags.Permission, id: "USER" }],
        }),
    }),
});

export const { useGetPermissionsQuery, useGetUserPermissionsQuery } = permissionsApi;
